import styled from "@emotion/styled";
import { GhostButton } from "src/components/Buttons";
import { OLD_BLUE } from "src/constants/colors";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin: 32px 32px 32px 0px;
  position: relative;
`;

export const UpperContainer = styled.div``;

export const KeyDetailsContainer = styled.div`
  background-color: rgba(243, 245, 248, 1);
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  height: fit-content;
  padding: 24px;
  width: 352px;
`;

export const Divider = styled.div`
  border-bottom: 1px solid rgba(228, 231, 236, 1);
  margin: 0px;
`;

export const ShowMoreButton = styled(GhostButton)`
  color: ${OLD_BLUE};
  padding-left: 8px;
  padding-right: 13px;
  margin-left: -8px;
  margin-top: 8px;
  width: fit-content;
`;
